import { createFileRoute, redirect } from '@tanstack/react-router'
import { AccountShell } from '../../../components/account/AccountShell'
import { WorkspaceSettingsSection } from '../../../components/account/WorkspaceSettingsSection'
import { isWorkspaceAdmin } from '../../../lib/api'
import { authClient } from '../../../lib/auth-client'
import { useWorkspaces, workspacesQueryOptions } from '../../../hooks/useWorkspaces'

export const Route = createFileRoute('/workspaces/$workspaceId/settings')({
  beforeLoad: async ({ context, params }) => {
    const { data: session } = await authClient.getSession()
    if (!session) {
      throw redirect({ to: '/login' })
    }

    const workspacesResult = await context.queryClient.ensureQueryData(
      workspacesQueryOptions(),
    )

    const workspace =
      workspacesResult.success
        ? workspacesResult.data.find((w) => w.id === params.workspaceId)
        : undefined

    if (!workspace) {
      throw redirect({ to: '/workspaces' })
    }

    return { session, workspace }
  },
  component: WorkspaceSettingsPage,
})

function WorkspaceSettingsPage() {
  const { workspace: contextWorkspace } = Route.useRouteContext()
  const { workspaceId } = Route.useParams()
  const { data: workspacesResult } = useWorkspaces()
  const workspace =
    (workspacesResult?.success
      ? workspacesResult.data.find((w) => w.id === workspaceId)
      : undefined) ?? contextWorkspace
  const isAdmin = isWorkspaceAdmin(workspace)

  return (
    <AccountShell>
      <WorkspaceSettingsSection workspace={workspace} isAdmin={isAdmin} />
    </AccountShell>
  )
}
